import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import nlTranslations from './locales/nl.json';
import enTranslations from './locales/en.json';

export const supportedLanguages = ['nl', 'en'] as const;
export type SupportedLanguage = typeof supportedLanguages[number];

export const languageNames: Record<SupportedLanguage, { native: string; flag: string }> = {
  nl: { native: 'Nederlands', flag: '🇳🇱' },
  en: { native: 'English', flag: '🇬🇧' },
};

const resources = {
  nl: { translation: nlTranslations },
  en: { translation: enTranslations },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'nl',
    defaultNS: 'translation',
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'nt2-language',
    },
  });

export default i18n;
